<template>
    <el-dialog :modal="false" v-draggable width="70%" :close-on-click-modal="false" @close="onModalClose" :title="'Contact' + (redHealthMayContactClaimant &&
  ((emailOrSms == 0 && emailProps.claimant != '') ||
  (emailOrSms == 1 && phoneProps.claimant != '')) ? 'Examinee /' : '') + ' Client / Specialist'" :visible.sync="loadModal">
            <div class="row d-flex align-items-center">
              <div class="col-4">
                <v-btn-toggle v-model="emailOrSms" mandatory @change="changeOption()">
                  <v-btn style="height: 30px" class="radio-toggle"> Email </v-btn>
                  <v-btn style="height: 30px" class="radio-toggle"> SMS </v-btn>
                </v-btn-toggle>
              </div>
              <div class="col-8 d-flex align-items-center">
                <el-select v-if="
                    (emailOrSms === 0 && emailProps.client !== '' ) ||
                    (emailOrSms === 1 && phoneProps.client !== '')" v-model="sendTo" :popper-append-to-body="false" @change="radioChange">
                  <el-option value="client" label="Client">Client</el-option>
                  <el-option value="claimant" label="Examinee">Examinee</el-option>
                  <el-option value="specialist" label="Specialist">Specialist</el-option>
                  <el-option value="rhadmin" label="RHAdmin">RHAdmin</el-option>
                  <el-option value="custom" label="Custom">Custom</el-option>
                </el-select>
                <el-select v-if="emailOrSms === 0" class="ml-2" filterable v-model="curTemplate" placeholder="Select Template" @change="onChangeSelect" :popper-append-to-body="false">
                  <el-option v-for="item in filteredRecords" :key="item.EmailTemplateID" :value="item.EmailTemplateID" :label="decodeURIComponent(item.TemplateName)">{{decodeURIComponent(item.TemplateName)}}</el-option>
                </el-select>
                <el-select v-else class="ml-2" filterable v-model="curTemplate" placeholder="Select Template" @change="onChangeSelect" :popper-append-to-body="false">
                  <el-option v-for="item in filterSms" :key="item.SmsTemplateID" :value="item.SmsTemplateID" :label="decodeURIComponent(item.TemplateName)">{{decodeURIComponent(item.TemplateName)}}</el-option>
                </el-select>
                <v-btn
                    dark
                    class="ml-2 btn-light"
                    v-show="sendTo === 'client' && emailOrSms === 0 && !hideButtons"
                    @click="resendBookingConfirmation">
                  Resend Booking Confirmation
                </v-btn>
              </div>
            </div>
            <form>
              <div>
                <div>
                  <div>
                    <table class="table">
                      <thead>
                        <tr style="height: 30px">
                          <th style="padding: 0 0 0 30px" class="icon-col">
                            <input
                              type="checkbox" size="medium"
                              class="form-checkbox-all"
                              style="margin-left: 10px"
                              v-model="selectAll"
                              @change="changeCheckboxAll($event.target.checked)"
                            />
                          </th>
                          <th style="width: 90%; padding: 0 15px" class="long-text">
                            Form Name
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div
                    :class="standardFiles.length > 5 ? 'content-scroll' : ''"
                  >
                    <table class="table">
                      <tbody>
                        <tr v-for="(file, index) in standardFiles" :key="index">
                          <td style="width: 10%" class="icon-col pt-0 pb-0">
                            <input
                              type="checkbox"
                              class="form-checkbox ml-5"
                              v-model="file.checked"
                              @change="changeCheckbox($event, file)"
                            />
                          </td>
                          <td
                            style="width: 75%"
                            class="long-text pt-0 pb-0"
                            data-placement="right"
                            data-toggle="tooltip"
                            :title="decodeURIComponent(file.name)"
                          >
                            <a :href="getUrl(file)" target="blank">{{
                              decodeURIComponent(file.name)
                            }}</a>
                          </td>
                          <td style="width: 15%" class="long-text pt-0 pb-0">
                            <el-button v-show="file.type === 'link'" @click="copyText(getUrl(file))" size="small">Copy Url</el-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="emailOrSms === 0" class="row">
                <div class="col-4">
                  <el-input
                    type="text"
                    v-model="email.Subject"
                    placeholder="Subject"
                    v-if="emailOrSms === 0"
                  />
                  <div v-if="hasError && !validateSubject" class="text-danger">
                    Email subject is required.
                  </div>
                </div>
                <div class="col-4" v-if="sendTo !== 'rhadmin'">
                  <el-input
                      type="text"
                      v-model="email.EmailTo"
                      placeholder="Email To"
                      v-show="emailOrSms === 0 && (sendTo === 'specialist' || sendTo === 'claimant')"
                  />
                  <el-select class="w-100"
                             v-model="email.EmailTo"
                             placeholder="Email To"
                             filterable
                             clearable
                             name="email"
                             autocomplete="email"
                             :popper-append-to-body="false"
                             @change="onSelectEmail"
                             default-first-option
                             allow-create v-show="emailOrSms === 0 && (sendTo === 'client' || sendTo === 'custom')">
                    <el-option v-for="(item, i) in listContacts" :key="i" :value="item" :label="item"></el-option>
                  </el-select>
                  <div v-if="hasError && !validateEmailTo" class="text-danger">
                    Email is required.
                  </div>
                </div>
                <div class="col-4">
                  <el-select multiple class="w-100" v-show="emailOrSms === 0"
                             placeholder="Email Cc"
                             v-model="email.EmailCc"
                             filterable
                             clearable
                             name="emailcc"
                             autocomplete="emailcc"
                             :popper-append-to-body="false"
                             @change="onSelectEmail"
                             default-first-option
                             allow-create>
                    <el-option v-for="(item, i) in listContacts" :key="i" :value="item" :label="item"></el-option>
                  </el-select>
                </div>
                <div class="col-4">
                  <el-select multiple class="w-100" v-show="emailOrSms === 0"
                             placeholder="Email Bcc"
                             v-model="email.EmailBcc"
                             filterable
                             clearable
                             name="emailbcc"
                             autocomplete="emailbcc"
                             default-first-option
                             :popper-append-to-body="false"
                             @change="onSelectEmail"
                             allow-create>
                    <el-option v-for="(item, i) in listContacts" :key="i" :value="item" :label="item"></el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="emailOrSms === 1" class="row">
                <div class="col-4">
                  <el-input
                      type="text"
                      v-model="phone"
                      placeholder="Phone Number"
                  />
                  <div v-if="hasError && !validatePhone" class="text-danger">
                    Please enter a valid mobile number in International format without spaces - i.e. +61400123456
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <Editor v-if="emailOrSms === 0" apiKey="5wu9mqdus3m0ugez0lnjdl6dcxezik3j0rnecxh62g4xf31p" :init="option" ref="editor"
                    v-model="email.Content"
                    placeholder="Message"/>
                  <textarea v-else v-model="email.Content" class="border" style="height: 100px" />
                  <div v-if="hasError && !validateMessage" class="text-danger">
                    Message body is required.
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn
                      class="white-button"
                      @click="handleModal($event)"
                      dark>Cancel</v-btn>
                    <v-btn dark @click="sendEmail">{{ isSending ? 'Sending...' : 'Send' }}</v-btn>
                  </div>
                </div>
              </div>

              <div class="row">
                <v-btn
                  dark
                  class="mr-2 btn-light"
                  v-if="sendTo == 'claimant' && emailOrSms == 0 && !hideButtons"
                  @click="resendConfirmationAttendance">
                  Resend Confirmation of Attendance
                </v-btn>
                <v-btn
                  dark
                  class="mr-2 btn-light"
                  v-if="sendTo == 'claimant' && emailOrSms == 0 && !hideButtons"
                  @click="resendConsentEmail">
                  Send Consent Reminder to Client
                </v-btn>

              </div>
            </form>
    </el-dialog>
</template>

<script>
import utilities from "@/assets/js/utilities";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/skins/ui/oxide/skin.css";

export default {
  name: "SendEmailModal",
  components: {
    Editor
  },
  props: [
    "client",
    "sendToProps",
    "emailProps",
    "nameProps",
    "emailSmsProps",
    "phoneProps",
    "bookingFiles",
    "bookingProps",
    "clientContact",
    "specialist",
    "locationName"
  ],
  data() {
    return {
      selectAll: false,
      option: {
        plugins: 'link image code table',
        height: 400,
        branding: false,
        menu: false,
        browser_spellcheck: true
      },
      records: [],
      filteredRecords: [],
      editContent: {},
      curTemplate: null,
      loadModal: false,
      redHealthMayContactClaimant: true,
      email: utilities.initEmail(),
      phone: '',
      commonFiles: [],
      loaded: false,
      byName: false,
      hasError: false,
      hideButtons: false,
      sendTo: "",
      listContacts: [],
      ccList: [],
      standardFiles: [],
      emailOrSms: 0,
      files: [],
      smsList: [],
      filterSms: [],
      isSending: false
    };
  },
  computed: {
    validateEmail() {
      return this.emailOrSms === 1 || (this.email && this.email.Content && this.email.Content !== "");
    },
    validateSubject() {
      return this.emailOrSms === 1 || (this.email && this.email.Subject && this.email.Subject !== "");
    },
    validateEmailTo() {
      return this.emailOrSms === 1 || this.sendTo === 'rhadmin' || (this.email && this.email.EmailTo && this.email.EmailTo !== "");
    },
    validateMessage() {
      return this.email.Content;
    },
    validatePhone() {
      return this.emailOrSms === 0 || this.sendTo === 'rhadmin' || (this.phone && this.phone.trim() !== '' && utilities.validatePhoneAU(this.phone));
    }
  },
  watch: {
    loadModal(val) {
      if (!val) {
        this.resetModalState();
      }
    },
    clientContact: {
      handler(value) {
        if (value && value.length > 0) {
          value.forEach(item => {
            if(item.NotificationEmailAddress) {
              this.listContacts.push(item.NotificationEmailAddress)
              this.ccList.push(item.NotificationEmailAddress)
            }
            if(item.EmailAddress) {
              this.listContacts.push(item.EmailAddress)
              this.ccList.push(item.EmailAddress)
            }
          })
          this.ccList.push(this.specialist.NotificationEmailAddress ? this.specialist.NotificationEmailAddress : this.specialist.EmailAddress)
          this.ccList.push(this.bookingProps.ClaimantEmail)
          let obj = value.find(item => item.IsPrimaryContact)
          if(obj) {
            this.email.EmailTo = obj.NotificationEmailAddress ? obj.NotificationEmailAddress : obj.EmailAddress
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    async getEmailTemplate() {
      const res = await utilities.getEmailTemplateByList()
      this.records = res.EmailTemplates ? res.EmailTemplates : []
      this.records = this.records.map(item => {
        return {
          ...item,
          Subject: decodeURIComponent(item.Subject),
          TemplateName: decodeURIComponent(item.TemplateName),
          EmailCc: item.EmailCc ? [decodeURIComponent(item.EmailCc)] : [],
          EmailBcc: item.EmailBcc ? [decodeURIComponent(item.EmailBcc)] : [],
          Body: decodeURIComponent(item.Body.replace(/%/g, '%25')),
        }
      })
    },
    getSMSTemplate() {
      utilities.getSMSTemplateForUser({pageSize: 999}).then(res => {
        this.smsList = res.EmailTemplates
        if(!this.phoneProps.client) {
          this.filterSms = this.smsList
          return
        }
        this.radioChange(this.sendToProps)
      })
    },
    copyText(textToCopy) {
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
    onSelectEmail() {
      this.$forceUpdate()
    },
    getEmailTo() {
      if(this.sendTo === 'client') {
        this.email.EmailTo = this.bookingProps.ClientContact.NotificationEmailAddress ? this.bookingProps.ClientContact.NotificationEmailAddress : this.bookingProps.ClientContact.EmailAddress
      } else if (this.sendTo === 'specialist') {
        this.email.EmailTo = this.specialist.NotificationEmailAddress ? this.specialist.NotificationEmailAddress : this.specialist.EmailAddress
      } else if (this.sendTo === 'claimant') {
        this.email.EmailTo = this.bookingProps.Case.ClaimantEmail
      } else {
        this.email.clientEmail = null
        this.email.EmailTo = null
      }
      this.$forceUpdate()
    },
    radioChange(v) {
      this.curTemplate = null
      console.log('------record--------')
      console.log(this.records)
      if(v === 'client') {
        this.filteredRecords = this.records.filter(item => item.EmailTo === 1)
      } else if (v === 'specialist') {
        this.filteredRecords = this.records.filter(item => item.EmailTo === 2)
      }  else if (v === 'claimant') {
        this.filteredRecords = this.records.filter(item => item.EmailTo === 3)
      }  else if (v === 'rhadmin') {
        this.filteredRecords = this.records.filter(item => item.EmailTo === 0)
      } else {
        this.filteredRecords = this.records
      }
      console.log(this.filteredRecords)
      this.getEmailTo()
      if(this.emailOrSms === 1) {
        this.phone = this.phoneProps[this.sendTo]
        if(v === 'client') {
          this.filterSms = this.smsList.filter(item => item.SendTo === 1)
        } else if (v === 'specialist') {
          this.filterSms = this.smsList.filter(item => item.SendTo === 2)
        }  else if (v === 'claimant') {
          this.filterSms = this.smsList.filter(item => item.SendTo === 3)
        }  else if (v === 'rhadmin') {
          this.filterSms = this.smsList.filter(item => item.SendTo === 0)
        }   else if (v === 'custom') {
          this.filterSms = this.smsList.filter(item => item.SendTo === 4)
        } else {
          this.filterSms = this.smsList
        }
      }
    },
    async onChangeSelect(v) {
      if (!v) {
        this.email = utilities.initEmail()
      } else {
        if(this.emailOrSms === 0) {
          await this.$store.dispatch('loading/setLoadComponent', true)
          const content = await utilities.getEmailTemplateRender({
            BookingID: this.bookingProps.BookingID,
            EmailTemplateID: v
          })
          await this.$store.dispatch('loading/setLoadComponent', false)
          this.email = _.cloneDeep(this.records.find(item => item.EmailTemplateID === v))
          this.email.Subject = content.Subject.replaceAll('&#x27;', "'")
          this.email.Content = this.getEmailAutoFill(content.Body)
          this.$forceUpdate()
        } else {
          await this.$store.dispatch('loading/setLoadComponent', true)
          const content = await utilities.getSMSTemplateRender({
            BookingID: this.bookingProps.BookingID,
            SmsTemplateID: v
          })
          await this.$store.dispatch('loading/setLoadComponent', false)
          this.email.Content = this.getEmailAutoFill(content)
        }
        this.getEmailTo()
      }
    },
    getEmailAutoFill(data) {
      // data = data.replaceAll('${ClientName}', decodeURIComponent(this.bookingProps.Case.Client.ClientName))
      // data = data.replaceAll('${ClientContactName}', this.bookingProps.ClientContact ? decodeURIComponent(this.bookingProps.ClientContact.ClientContactFullName) : '')
      // data = data.replaceAll('${BookingId}', this.bookingProps.BookingID)
      // data = data.replaceAll('${BookingType}', this.bookingProps.BookingType.BookingTypeName)
      // data = data.replaceAll('${BookingStatus}', decodeURIComponent(this.bookingProps.Status.StatusDescription))
      // data = data.replaceAll('${Specialty}', this.bookingProps.Specialist.Qualifications.map(item => item.QualificationName).join(','))
      // data = data.replaceAll('${BookingTime}', window.moment(this.bookingProps.BookingDateTime).format('DD/MM/YYYY hh:mm A'))
      // data = data.replaceAll('${ClaimantName}', decodeURIComponent(this.bookingProps.Case.ClaimantFullName))
      // data = data.replaceAll('${ClaimantBookingDateTime}', this.formatDate(this.bookingProps.ClaimantBookingDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss"))
      // data = data.replaceAll('${Specialist}', utilities.getSpecialistFullNameUpper(this.bookingProps.Specialist))
      // data = data.replaceAll('${Location}', decodeURIComponent(this.bookingProps.Location.LocationName))
      // data = data.replaceAll('${CaseReferenceNumber}', this.bookingProps.Case.CaseReference)
      // data = data.replaceAll('${ClaimantLocation}', decodeURIComponent(this.bookingProps.ClaimantLocation))
      // data = data.replaceAll('${VideoLinkURL}', this.bookingProps.VideoLinkURL ? this.bookingProps.VideoLinkURL.replace(/"/g, "'"): '')
      // data = data.replaceAll('${PaperworkDue}', window.moment(this.bookingProps.PaperworkDue).format('DD/MM/YYYY'))
      // data = data.replaceAll('${DateOfAccident}', this.bookingProps.AccidentDate)
      // data = data.replaceAll('${AdditionalTime}', this.bookingProps.BookingHours ? this.formatHoursString(this.bookingProps.BookingHours.filter(item => item.Status === '0')): '')
      // data = data.replaceAll('${Pre-approvedHours}', this.bookingProps.BookingHours ? this.formatHoursString(this.bookingProps.BookingHours.filter(item => item.Status === '3')): '')
      // data = data.replaceAll('${ExamineeLocationForVideoLink}', this.bookingProps.ClaimantLocation)
      // data = data.replaceAll('${ClaimantStateForVideoLink}', this.bookingProps.ClaimantStateDuringBooking)
      // data = data.replaceAll('${ClaimantDateOfBirth}', window.moment(this.bookingProps.Case.DateofBirth).format('DD/MM/YYYY'))
      // data = data.replaceAll('${ClientContactEmailAddress}', this.bookingProps.ClientContact ? (this.bookingProps.ClientContact.NotificationEmailAddress || this.bookingProps.ClientContact.EmailAddress) : '')
      // data = data.replaceAll('${ClaimantAddress}', this.getAddress())
      // data = data.replaceAll('${ClientAddress}', this.getClientAddress())
      // data = data.replaceAll('${ClaimantCountry}', this.bookingProps.ClaimantCountryDuringBooking !== 'International' ? this.bookingProps.ClaimantCountryDuringBooking : this.bookingProps.ClaimantTimeZoneDuringBooking)
      //
      data = data.replaceAll("&#x27;", "'")
      return data
    },

    formatDate(date, format = "DD/MM/YYYY", currentFormat = "YYYY-MM-DD") {
      if (date != '' && date != '0000-00-00') {
        return utilities.formatDate(date, format, currentFormat)
      }
      return ''
    },

    getAddress(){
      let str = ''
      if(this.bookingProps.Case.ClaimantAddressLine1) {
        str += this.bookingProps.Case.ClaimantAddressLine1 + '<br>'
      }
      if(this.bookingProps.Case.ClaimantAddressLine2) {
        str += this.bookingProps.Case.ClaimantAddressLine2 + '<br>'
      }
      if(this.bookingProps.Case.ClaimantCity) {
        str += this.bookingProps.Case.ClaimantCity + ', '
      }
      if(this.bookingProps.Case.ClaimantState) {
        str += this.bookingProps.Case.ClaimantState + ', '
      }
      if(this.bookingProps.Case.ClaimantPostcode) {
        str += this.bookingProps.Case.ClaimantPostcode
      }
      return decodeURIComponent(str)
    },

    getClientAddress(){

      let str = ''
      if(this.client.addressLine1) {
        str += this.client.AddressLine1 + '<br>'
      }
      if(this.client.addressLine2) {
        str += this.client.AddressLine2 + '<br>'
      }
      if(this.client.City) {
        str += this.client.City + ', '
      }
      if(this.client.State) {
        str += this.client.State + ', '
      }
      if(this.client.Postcode) {
        str += this.client.Postcode
      }
      return decodeURIComponent(str)
    },

    formatHoursString(arr) {
      let str = ''
      arr.forEach(item => {
        str+= `${item['service']}: ${item.numberOfHours} hours <br>`
      })
      return str
    },

    resetModalState() {
      this.email = utilities.initEmail();
      this.phone = '';
      this.curTemplate = null;
      this.hasError = false;
      this.selectAll = false;
      this.files = [];
      this.standardFiles = [];
      this.emailOrSms = 0;
      this.sendTo = this.sendToProps || '';
      this.isSending = false;
      this.$nextTick(() => {
        const editor = this.$refs.editor && this.$refs.editor.editor;
        if (editor) {
          editor.setContent('');
        }
      });
    },

    onModalClose() {
      $("html").removeClass("modal-mask-open");
    },

    handleModal(e) {
      this.loadModal = !this.loadModal;
      if (this.loadModal) {
        $("html").addClass("modal-mask-open");
      } else {
        $("html").removeClass("modal-mask-open");
      }
    },

    changeOption() {
      if (this.emailOrSms == 0 && this.emailProps.claimant == '') {
         this.sendTo = 'client'
         this.radioChange(this.sendTo)
      } else if (this.emailOrSms === 1 && this.phoneProps.client) {
        this.sendTo = 'custom'
        this.filterSms = this.smsList.filter(item => item.SendTo === 4)
      } else if (this.emailOrSms === 1 && !this.phoneProps.client) {
        this.filterSms = this.smsList
      }
    },

    sortName() {
      this.commonFiles.sort((a, b) => {
        if (this.byName) {
          // ASC
          return a.fileName > b.fileName ? 1 : -1;
        } else {
          // DESC
          return a.fileName < b.fileName ? 1 : -1;
        }
      });
      this.byName = !this.byName;
    },
    changeCheckboxAll(e) {
      this.files = []
      if (e) {
        this.files = this.standardFiles
        $(".form-checkbox").prop("checked", true);
      } else {
        this.files = []
        $(".form-checkbox").prop("checked", false);
      }
    },
    changeCheckbox(e, file) {
      file.checked = e.target.checked
      if (e.target.checked) {
        this.files.push(file);
      } else {
        this.files = this.files.filter((x) => x.name !== e.target.value);
      }
      if (this.standardFiles.length === this.files.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      this.$forceUpdate()
    },

    resendBookingConfirmation() {
      if(this.sendTo === 'client') {
        this.$confirm({
          content: 'Are you sure you want to resend booking confirmation?',
          onConfirm: async () => {
            await this.callsendBookingEmail("BookingConfirmation")
          }
        })
      } else {
        this.callsendBookingEmail("BookingConfirmation")
      }

    },

    resendConfirmationAttendance() {
      this.$confirm({
        content: 'Are you sure you want to resend confirmation attendance?',
        onConfirm: async () => {
          await this.callsendBookingEmail("AttendanceConfirmation")
        }
      })
    },

    resendConsentEmail() {
      this.$confirm({
        content: 'Are you sure you want to send consent reminder to client?',
        onConfirm: async () => {
          await this.callsendBookingEmail("ConsentConfirmation")
        }
      })
    },

    async callsendBookingEmail(emailType) {
      var fullName = ""
      var email = ""
      if (this.sendTo == 'claimant') {
        fullName = this.nameProps.claimant
        email = this.emailProps.claimant
      } else {
        fullName = this.nameProps.client
        email = this.emailProps.client
      }

      if ((emailType == "ConsentConfirmation" || emailType == "AttendanceConfirmation") && email == "") {
        fullName = this.nameProps.client
        email = this.emailProps.client
      }

      var params = {
        EmailTo: email,
        EmailType: emailType,
        BookingID: this.$parent.booking.BookingID,
      }

      var res = await utilities.postResendBookingEmail(params);
      if (res) {
        if(emailType === 'BookingConfirmation') {
          this.$parent.successMessage =
              "Confirmation Email re-sent to " + (this.sendToProps === 'client' ? 'Client Contact' : this.sendToProps) + ".";
          utilities.showAlert(".alert-success");
          this.handleModal();
        } else if (emailType === 'AttendanceConfirmation') {
          this.$parent.successMessage = "Confirmation of Attendance re-sent to Examinee"
          utilities.showAlert(".alert-success");
          this.handleModal();
        } else if (emailType === 'ConsentConfirmation') {
          this.$parent.successMessage = "Request for Consent Form re-sent to Examinee"
          utilities.showAlert(".alert-success");
          this.handleModal();
        }
        this.$emit('sendSuccess')
      }
    },

    showHideButton() {
      if (this.$parent.booking.bookingTypeName == "FCE Lite" || this.$parent.booking.bookingTypeName == "FCE Lite by Video") {
        this.hideButtons = true
      } else {
        this.hideButtons = false
      }
    },

    async sendEmail() {
      if (this.isSending) return;
      this.hasError = false;
      if (!this.validateSubject || !this.validateMessage || !this.validateEmail || !this.validateEmailTo || !this.validatePhone) {
        this.hasError = true;
        return;
      }

      this.isSending = true;
      this.sendToProps = this.sendTo;
      await this.$store.dispatch("loading/setLoadComponent", true);
      try {
        if (this.emailOrSms === 0) {
          let params = {
            Content: this.email.Content,
            Subject: this.email.Subject,
            Method: "email",
            EmailCc: this.email.EmailCc ? this.email.EmailCc.join(',') : '',
            EmailBcc: this.email.EmailBcc ? this.email.EmailBcc.join(',') : '',
            BookingID: this.$parent.booking.BookingID,
            CurrentDate: window.moment().format('YYYY-MM-DD HH:mm:ss'),
          };
          if(this.sendTo === 'rhadmin') {
            params.SendToRH2 = 1
          } else {
            params.EmailTo = this.email.EmailTo
          }
          let attach = []
          let standards = []
          this.files.forEach(item => {
            if(item.type === 'link') {
              standards.push(item.name)
            } else {
              attach.push(item.name)
            }
          });
          if(attach.length > 0) params.Attachments = attach
          if(standards.length > 0) params.StandardAttachments = standards
          const res = await utilities.sendEmailFromBooking(params);
          if (res) {
            this.$parent.successMessage =
              "Email sent to " + this.sendToProps + ".";
            utilities.showAlert(".alert-success");
            this.handleModal();
            this.$emit('sendSuccess')
          }
        } else {
          let phone = this.phone
          if(phone.charAt(0) == '0' && phone.charAt(1) == '4') phone = "+61"+phone.substring(1)
          var params = {
            PhoneNumber: phone,
            Content: this.email.Content,
            Method: "sms",
            BookingID: this.$parent.booking.BookingID,
            UserID: this.$parent.user.id,
            Username: this.$parent.user.name,
            CurrentDate: window.moment().format('YYYY-MM-DD HH:mm:ss'),
          };
          params.Attachments = this.files.map(item => {
            if(item.type === 'link') {
              return this.getUrl(item)
            } else {
              return item.name
            }
          });
          var res = await utilities.sendEmailFromBooking(params);
          if (res) {
            this.$parent.successMessage =
              "SMS sent to " + this.sendToProps + ".";
            utilities.showAlert(".alert-success");
            this.handleModal();
            this.$emit('sendSuccess')
          }
        }
      } finally {
        this.isSending = false;
        await this.$store.dispatch("loading/setLoadComponent", false);
      }
    },

    getUrl(file) {
      if(file.type === 'link') {
        return utilities.getConsentFormUrl(file.name);
      } else {
        return file.name
      }
    },
  },
  beforeMount() {
    this.sendTo = this.sendToProps
    this.radioChange(this.sendTo)
    if (this.$parent.booking.bookingTypeName == "FCE Lite" || this.$parent.booking.bookingTypeName == "FCE Lite by Video") {
      this.hideButtons = true
    } else {
      this.hideButtons = false
    }
  },
  mounted() {
    console.log(this.emailProps)
  },
  async updated() {
    // if (this.loaded == false) {
    //   this.standardFiles = await utilities.getStandardForms();
    //   this.emailOrSms = this.emailSmsProps;
    //   this.loaded = true;
    //   this.standardFiles.sort((a, b) => {
    //     return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    //   });
    // }
  },
};
</script>
